// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-success-with-action {
  width: 480px;
}
.dialog-success-with-action__action {
  margin-top: 20px;
}
.dialog-success-with-action__illustration {
  padding: 45px 30px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogSuccessWithAction/DialogSuccessWithAction.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,gBAAA;AACR;AAEI;EACI,kBAAA;AAAR","sourcesContent":[".dialog-success-with-action {\n  width: 480px;\n}\n.dialog-success-with-action__action {\n  margin-top: 20px;\n}\n.dialog-success-with-action__illustration {\n  padding: 45px 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
